import axiosInstance from "./instance";

// Get All Orders
const fetchOrders = async (page, status, deliveryType, limit = 15) => {
    const response = await axiosInstance.get('/orders', {
        params: {
            page,
            limit,
            status,
            deliveryType,
        }
    });
    return response.data;
}

// For Dashbaord Graph

const fetchDashboardOrders = async () => {
    const response = await axiosInstance.get('/dashboard/orders');
    return response.data;
}

// Get Solo Order
const fetchOrder = async (orderId) => {
    const response = await axiosInstance.get(`/orders/${orderId}`);
    return response.data;
}

// Get All Riders
const fetchRiders = async () => {
    const response = await axiosInstance.get(`/orders/assignable-riders`);
    return response.data;
}

// Assign Order to Riders
const assignOrders = async (riderId, orders) => {
    const response = await axiosInstance.post(`/orders/assign`, {
        riderId,
        orders,
    });
    return response.data;
}

export { fetchOrders, fetchDashboardOrders, fetchOrder, fetchRiders, assignOrders };
